<template>
  <transition name="modal-fade-zoom">
    <div v-if="news" class="news-modal-overlay" @click.self="$emit('close')">
      <div class="news-modal-dialog" role="dialog" aria-modal="true">
        <div class="news-modal-content">
          <header class="news-modal-header">
            <div>
              <span class="badge bg-dark text-warning text-uppercase">{{ news.category }}</span>
              <h4 class="news-modal-title">{{ news.title }}</h4>
              <p class="news-modal-date mb-0">
                <i class="bi bi-clock-history me-2"></i>
                {{ news.date }} · {{ news.tags.join(' · ') }}
              </p>
            </div>
            <button type="button" class="btn-close" aria-label="Fechar" @click="$emit('close')"></button>
          </header>

          <section v-if="news.image" class="news-modal-cover" :style="{ backgroundImage: `url(${news.image})` }">
          </section>

          <section class="news-modal-body">
            <p v-for="(paragraph, index) in news.body" :key="`paragraph-${index}`" class="news-modal-paragraph">
              {{ paragraph }}
            </p>

            <div v-if="news.highlights?.length" class="news-modal-highlights">
              <h5 class="text-warning text-uppercase small mb-3">
                <i class="bi bi-lightning-charge me-2"></i>
                Pontos de destaque
              </h5>
              <ul class="list-unstyled mb-0">
                <li v-for="(item, index) in news.highlights" :key="`highlight-${index}`">
                  <i class="bi bi-chevron-right me-2"></i>
                  {{ item }}
                </li>
              </ul>
            </div>
          </section>

          <footer class="news-modal-footer">
            <button type="button" class="btn btn-vampire" @click="$emit('close')">
              <i class="bi bi-arrow-return-left me-2"></i>
              Voltar às notícias
            </button>
          </footer>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'NewsModal',
  props: {
    news: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.news-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  z-index: 1060;
  overflow-y: auto;
}

.news-modal-dialog {
  width: min(960px, 100%);
}

.news-modal-content {
  background: linear-gradient(145deg, #f6f0e9 0%, #ede3d9 100%);
  border: 1px solid rgba(139, 0, 0, 0.25);
  border-radius: 1rem;
  color: #241515;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.55);
  overflow-y: auto;
}

.news-modal-header {
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1.5rem;
  border-bottom: 1px solid rgba(139, 0, 0, 0.18);
}

.news-modal-title {
  margin: 0.75rem 0 0.5rem;
}

.news-modal-date {
  color: rgba(51, 31, 31, 0.7);
  font-size: 0.9rem;
}

.news-modal-cover {
  min-height: 220px;
  background-size: cover;
  background-position: center;
  position: relative;
}

.news-modal-cover::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.38), rgba(0, 0, 0, 0.65));
}

.news-modal-body {
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
  color: #2e1c1c;
}

.news-modal-paragraph {
  margin-bottom: 0;
  color: rgba(36, 21, 21, 0.86);
  line-height: 1.6;
}

.news-modal-highlights {
  background: rgba(139, 0, 0, 0.08);
  border: 1px solid rgba(139, 0, 0, 0.2);
  border-radius: 0.75rem;
  padding: 1rem 1.25rem;
}

.news-modal-highlights li {
  margin-bottom: 0.5rem;
  color: rgba(36, 21, 21, 0.86);
}

.news-modal-highlights li:last-child {
  margin-bottom: 0;
}

.news-modal-footer {
  padding: 1.25rem 1.75rem 1.75rem;
  border-top: 1px solid rgba(139, 0, 0, 0.15);
  display: flex;
  justify-content: flex-end;
}

.btn-vampire {
  background: var(--vampire-red);
  border: none;
  color: #f8f9fa;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.btn-vampire:hover {
  background: var(--vampire-blood);
}

@media (max-width: 768px) {
  .news-modal-header {
    flex-direction: column;
    align-items: stretch;
  }

  /* ✅ IMAGEM MENOR NO CELULAR */
  .news-modal-cover {
    min-height: 120px;
  }

  .news-modal-body {
    padding: 1.1rem;
    font-size: 0.95rem;
  }

  .news-modal-footer {
    padding: 1rem;
  }

  .news-modal-content {
    max-height: 90vh;
  }
}

@media (max-width: 576px) {
  .news-modal-cover {
    min-height: 90px;
  }

  .news-modal-title {
    font-size: 1.1rem;
  }

  .news-modal-paragraph {
    line-height: 1.5;
  }
}
</style>
